import { useTranslation } from 'react-i18next';
import { InfiosIcon } from '@infios/uikit/react';
import type { Insight } from '../../interfaces/chat';
import styles from './InsightsList.module.css';

interface InsightsListProps {
  insights: Insight[];
}

/** FR-04 "Insight Generator" output — bulleted, icon-prefixed by severity. */
export function InsightsList({ insights }: InsightsListProps) {
  const { t } = useTranslation();
  if (insights.length === 0) return null;

  return (
    <div className={styles.wrap} data-testid="insights-list">
      <h4 className={styles.heading}>{t('ChatbotUI.OrderInsight.Insights')}</h4>
      <ul className={styles.list}>
        {insights.map((insight) => (
          <li key={insight.id} className={styles.item}>
            <InfiosIcon
              name={insight.severity === 'WARNING' ? 'alert' : 'information-outline'}
              className={insight.severity === 'WARNING' ? styles.iconWarning : styles.iconInfo}
            />
            <span>{insight.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
